export const ROLES = {
    GLOBAL_ADMIN: 'Global Admin',
    TENANT_ADMIN: 'Tenant Admin',
    TAX_PAYER: 'Taxpayer',
    AUDITOR: 'Auditor',
    ACCOUNTANT: 'Accountant',
    Admin: 'Admin',
    Employee: 'Employee',
    SDGCurator: 'SDG Financing Hub Curator',
    UnileverCurator: 'Unilever Curator',
    PFANCurator: 'PFAN Curator',
    Manager: 'Manager',
}